import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";
// import { usePageTimeTracking } from "../hooks/usePageTimeTracking";

const PageTransition = ({ children }) => {
  const location = useLocation();
  // usePageTimeTracking(); // No longer needed

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -5 }}
      transition={{
        type: "spring",
        stiffness: 350,
        damping: 35,
        duration: 0.15,
        opacity: { duration: 0.1 },
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.1 }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

export default PageTransition;
